module.exports = __webpack_public_path__ + "static/drone.27f07bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drone.jpg
// module id = ./src/assets/drone.jpg
// module chunks = 246384609461072